module.exports = __webpack_public_path__ + "img/3-quad.fdbf23c4.png";